import InvoiceTemplates from '../../../../store/billing/invoice_templates';

angular
    .module('festzelt-os.billing.invoice_templates')
    .factory('InvoiceTemplates', [
        '$injector',
        'InvoiceTemplate',
        ($injector, InvoiceTemplate) => new InvoiceTemplates(InvoiceTemplate, {
            injector: $injector
        })
    ]);



// WEBPACK FOOTER //
// ./src/app/pages/billing/invoice_templates/store/invoices_templates.js